// utilities
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    /**
 * Unpacks the imageInfo object into specific settings used by IRVIEWER and valid settings that can be updated by the user.
 *
 * @param {Object} [imageInfo={}] - An object of image information to be unpacked. Defaults to an empty object.
 * @param {string} [temperatureUnit="C"] - The unit of temperature to be used. Defaults to "C".
 * @param {number} [frameIndex=CAMERA_FRAME_INDEX] - The index of the frame to be checked. If the image was captured as a video, this relates to specific keys in imageInfo associated with a specific frame of an is2. Defaults to CAMERA_FRAME_INDEX.
 *
 * @returns {Object} - An object containing the unpacked settings. If there are no keys in the imageInfo object, it returns an empty object.
 *
 * The function starts by initializing an empty settings object.
 *
 * If the imageInfo object has keys, it gets the image information for the given frame index and unpacks the settings from various attributes of the imageInfo object, including metadata head, basicPresentationFlags, irPaletteSetup, cal, MARKERS, IRVIEWER, TEXTNOTES, OCRText, and temperatureUnit.
 *
 * Finally, the function returns the unpacked settings. If the settings object is null or undefined, it returns an empty object.
 */ default: function() {
        return unpackImageInfo;
    },
    getIRPaletteSetup: function() {
        return getIRPaletteSetup;
    },
    getIRVIEWERProps: function() {
        return getIRVIEWERProps;
    }
});
const _editor = require("../../../utilities/editor");
const _utilities = require("../../../utilities");
const _enums = require("../enums");
const _enums1 = require("../../../enums");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const CAMERA_FRAME_INDEX = 0;
function getMetadataHead(imageInfo = {}) {
    const KEY_INFO_DATA = _enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA;
    const { [KEY_INFO_DATA]: info = {} } = imageInfo;
    var _info_capturedBackgroundTempC, _info_capturedEmissivity, _info_capturedTransmissionFactor;
    return {
        capturedBackgroundTempC: (_info_capturedBackgroundTempC = info === null || info === void 0 ? void 0 : info.capturedBackgroundTempC) !== null && _info_capturedBackgroundTempC !== void 0 ? _info_capturedBackgroundTempC : 22,
        capturedEmissivity: (_info_capturedEmissivity = info === null || info === void 0 ? void 0 : info.capturedEmissivity) !== null && _info_capturedEmissivity !== void 0 ? _info_capturedEmissivity : 1,
        capturedTransmissionFactor: (_info_capturedTransmissionFactor = info === null || info === void 0 ? void 0 : info.capturedTransmissionFactor) !== null && _info_capturedTransmissionFactor !== void 0 ? _info_capturedTransmissionFactor : 1
    };
}
function getBasicPresentationFlags(imageInfo = {}) {
    const KEY_INFO_DATA = _enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA;
    const { [KEY_INFO_DATA]: info = {} } = imageInfo;
    const { basicPresentationFlags } = info;
    return {
        pipMode: (0, _editor.pipToBool)(basicPresentationFlags === null || basicPresentationFlags === void 0 ? void 0 : basicPresentationFlags.pipMode),
        irAlphaLevel: (0, _editor.fusionToNormalized)(basicPresentationFlags === null || basicPresentationFlags === void 0 ? void 0 : basicPresentationFlags.irAlphaLevel)
    };
}
function getIRPaletteSetup(imageInfo = {}) {
    const KEY_INFO_DATA = _enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA;
    const { [KEY_INFO_DATA]: info = {} } = imageInfo;
    const { irPaletteSetup } = info;
    var _irPaletteSetup_irOrientation, _irPaletteSetup_paletteScheme, _irPaletteSetup_backgroundTemp, _irPaletteSetup_paletteRangeMinTempC, _irPaletteSetup_paletteRangeMaxTempC;
    return {
        irOrientation: (0, _editor.indexToRotation)((_irPaletteSetup_irOrientation = irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.irOrientation) !== null && _irPaletteSetup_irOrientation !== void 0 ? _irPaletteSetup_irOrientation : 0),
        paletteScheme: (_irPaletteSetup_paletteScheme = irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.paletteScheme) !== null && _irPaletteSetup_paletteScheme !== void 0 ? _irPaletteSetup_paletteScheme : _enums.PaletteDefault.id,
        paletteScaleMode: irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.paletteScaleMode,
        backgroundTemp: (_irPaletteSetup_backgroundTemp = irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.backgroundTemp) !== null && _irPaletteSetup_backgroundTemp !== void 0 ? _irPaletteSetup_backgroundTemp : 22,
        paletteRangeMinTempC: (_irPaletteSetup_paletteRangeMinTempC = irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.paletteRangeMinTempC) !== null && _irPaletteSetup_paletteRangeMinTempC !== void 0 ? _irPaletteSetup_paletteRangeMinTempC : 0,
        paletteRangeMaxTempC: (_irPaletteSetup_paletteRangeMaxTempC = irPaletteSetup === null || irPaletteSetup === void 0 ? void 0 : irPaletteSetup.paletteRangeMaxTempC) !== null && _irPaletteSetup_paletteRangeMaxTempC !== void 0 ? _irPaletteSetup_paletteRangeMaxTempC : 100
    };
}
function getCalProps(imageInfo = {}) {
    var _imageInfo_CALIBRATION_DATA_calRangesInfo, _imageInfo_CALIBRATION_DATA;
    const calRangesInfo = ((_imageInfo_CALIBRATION_DATA = imageInfo.CALIBRATION_DATA) === null || _imageInfo_CALIBRATION_DATA === void 0 ? void 0 : (_imageInfo_CALIBRATION_DATA_calRangesInfo = _imageInfo_CALIBRATION_DATA.calRangesInfo) === null || _imageInfo_CALIBRATION_DATA_calRangesInfo === void 0 ? void 0 : _imageInfo_CALIBRATION_DATA_calRangesInfo[0]) || {};
    var _calRangesInfo_calRangeMinTempC, _calRangesInfo_calRangeMaxTempC, _calRangesInfo_minDisplayableTempC, _calRangesInfo_maxDisplayableTempC;
    return {
        calRangeMinTempC: (_calRangesInfo_calRangeMinTempC = calRangesInfo.calRangeMinTempC) !== null && _calRangesInfo_calRangeMinTempC !== void 0 ? _calRangesInfo_calRangeMinTempC : -20,
        calRangeMaxTempC: (_calRangesInfo_calRangeMaxTempC = calRangesInfo.calRangeMaxTempC) !== null && _calRangesInfo_calRangeMaxTempC !== void 0 ? _calRangesInfo_calRangeMaxTempC : 80,
        minDisplayableTempC: (_calRangesInfo_minDisplayableTempC = calRangesInfo.minDisplayableTempC) !== null && _calRangesInfo_minDisplayableTempC !== void 0 ? _calRangesInfo_minDisplayableTempC : -30,
        maxDisplayableTempC: (_calRangesInfo_maxDisplayableTempC = calRangesInfo.maxDisplayableTempC) !== null && _calRangesInfo_maxDisplayableTempC !== void 0 ? _calRangesInfo_maxDisplayableTempC : 90
    };
}
function getMarkerProps(imageInfo = {}) {
    var _Hotpoint_characteristics, _Coldpoint_characteristics;
    const KEY_MARKERS = _enums.ImageInfoKeys.MARKERS;
    const { [KEY_MARKERS]: MARKERS = {} } = imageInfo;
    const { STANDARD: { Hotpoint = {}, Coldpoint = {} } } = MARKERS;
    var _Hotpoint_characteristics_markerTempC_Average, _Coldpoint_characteristics_markerTempC_Average, _getVisibleStandardMarkers;
    return {
        MARKERS: MARKERS,
        hotpoint: (_Hotpoint_characteristics_markerTempC_Average = Hotpoint === null || Hotpoint === void 0 ? void 0 : (_Hotpoint_characteristics = Hotpoint.characteristics) === null || _Hotpoint_characteristics === void 0 ? void 0 : _Hotpoint_characteristics.markerTempC_Average) !== null && _Hotpoint_characteristics_markerTempC_Average !== void 0 ? _Hotpoint_characteristics_markerTempC_Average : 0,
        coldpoint: (_Coldpoint_characteristics_markerTempC_Average = Coldpoint === null || Coldpoint === void 0 ? void 0 : (_Coldpoint_characteristics = Coldpoint.characteristics) === null || _Coldpoint_characteristics === void 0 ? void 0 : _Coldpoint_characteristics.markerTempC_Average) !== null && _Coldpoint_characteristics_markerTempC_Average !== void 0 ? _Coldpoint_characteristics_markerTempC_Average : 100,
        standardMarkers: (_getVisibleStandardMarkers = (0, _utilities.getVisibleStandardMarkers)(MARKERS)) !== null && _getVisibleStandardMarkers !== void 0 ? _getVisibleStandardMarkers : []
    };
}
function getIRVIEWERProps(imageInfo = {}) {
    const KEY_IRVIEWER = _enums.ImageInfoKeys.IRVIEWER;
    // irviewer keys
    const KEY_GLOBAL_MARKER_VISIBLE = _enums.ValidSettings.GLOBAL_MARKER_VISIBLE;
    const KEY_STATUS = _enums.ValidSettings.STATUS;
    const KEY_REFERENCE_MARKER_ID = _enums.ValidSettings.REFERENCE_MARKER_ID;
    const KEY_ASSET_TAG = _enums.ValidSettings.ASSET_TAG;
    const { [KEY_IRVIEWER]: IRVIEWER = {} } = imageInfo;
    var _IRVIEWER_KEY_GLOBAL_MARKER_VISIBLE, _IRVIEWER_KEY_STATUS, _IRVIEWER_KEY_REFERENCE_MARKER_ID, _IRVIEWER_KEY_ASSET_TAG;
    return {
        [KEY_GLOBAL_MARKER_VISIBLE]: (_IRVIEWER_KEY_GLOBAL_MARKER_VISIBLE = IRVIEWER === null || IRVIEWER === void 0 ? void 0 : IRVIEWER[KEY_GLOBAL_MARKER_VISIBLE]) !== null && _IRVIEWER_KEY_GLOBAL_MARKER_VISIBLE !== void 0 ? _IRVIEWER_KEY_GLOBAL_MARKER_VISIBLE : true,
        [KEY_STATUS]: (_IRVIEWER_KEY_STATUS = IRVIEWER === null || IRVIEWER === void 0 ? void 0 : IRVIEWER[KEY_STATUS]) !== null && _IRVIEWER_KEY_STATUS !== void 0 ? _IRVIEWER_KEY_STATUS : _utilities.getStatusCodes[0],
        [KEY_REFERENCE_MARKER_ID]: (_IRVIEWER_KEY_REFERENCE_MARKER_ID = IRVIEWER === null || IRVIEWER === void 0 ? void 0 : IRVIEWER[KEY_REFERENCE_MARKER_ID]) !== null && _IRVIEWER_KEY_REFERENCE_MARKER_ID !== void 0 ? _IRVIEWER_KEY_REFERENCE_MARKER_ID : "",
        [KEY_ASSET_TAG]: (_IRVIEWER_KEY_ASSET_TAG = IRVIEWER === null || IRVIEWER === void 0 ? void 0 : IRVIEWER[KEY_ASSET_TAG]) !== null && _IRVIEWER_KEY_ASSET_TAG !== void 0 ? _IRVIEWER_KEY_ASSET_TAG : ""
    };
}
function getTEXTNOTES(imageInfo = {}) {
    const KEY_TEXTNOTES = _enums.ImageInfoKeys.TEXTNOTES;
    var _imageInfo_KEY_TEXTNOTES;
    return {
        [KEY_TEXTNOTES]: (_imageInfo_KEY_TEXTNOTES = imageInfo === null || imageInfo === void 0 ? void 0 : imageInfo[KEY_TEXTNOTES]) !== null && _imageInfo_KEY_TEXTNOTES !== void 0 ? _imageInfo_KEY_TEXTNOTES : []
    };
}
function getOCRText(imageInfo = {}) {
    const KEY_PHOTONOTES = _enums.ImageInfoKeys.PHOTONOTES;
    const KEY_OCR_TEXT = _enums.ValidSettings.OCR_TEXT;
    let ocrTextArray = [];
    var _imageInfo_KEY_PHOTONOTES;
    const photonotes = (_imageInfo_KEY_PHOTONOTES = imageInfo[KEY_PHOTONOTES]) !== null && _imageInfo_KEY_PHOTONOTES !== void 0 ? _imageInfo_KEY_PHOTONOTES : [];
    photonotes.forEach((photonote)=>{
        var _photonote_KEY_OCR_TEXT;
        const ocrText = (_photonote_KEY_OCR_TEXT = photonote[KEY_OCR_TEXT]) !== null && _photonote_KEY_OCR_TEXT !== void 0 ? _photonote_KEY_OCR_TEXT : "";
        ocrTextArray.push(ocrText);
    });
    return {
        [KEY_OCR_TEXT]: ocrTextArray
    };
}
function unpackImageInfo(imageInfo = {}, temperatureUnit = _enums1.temperatureUnits.CELSIUS, frameIndex = CAMERA_FRAME_INDEX) {
    let settings = {};
    if (Object.keys(imageInfo).length > 0) {
        const imageInfoFrame = (0, _utilities.getImageInfoByFrameIndex)(imageInfo, frameIndex);
        settings = _object_spread_props(_object_spread({}, getMetadataHead(imageInfoFrame), getBasicPresentationFlags(imageInfoFrame), getIRPaletteSetup(imageInfoFrame), getCalProps(imageInfoFrame), getMarkerProps(imageInfoFrame), getIRVIEWERProps(imageInfoFrame), getTEXTNOTES(imageInfoFrame), getOCRText(imageInfoFrame)), {
            temperatureUnit
        });
    }
    return settings !== null && settings !== void 0 ? settings : {};
}
